import styled from 'styled-components';

export const Layout = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  width: 100%;
`;

export const Viewport = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 0;
  position: relative;
`;

export const CornerTL = styled.div`
  left: 0;
  margin: 12px;
  position: absolute;
  top: 0;
`;

export const CornerTR = styled.div`
  margin: 12px;
  position: absolute;
  right: 0;
  top: 0;
`;

export const CornerBL = styled.div`
  bottom: 0;
  left: 0;
  margin: 12px;
  position: absolute;
`;
